<ion-accordion value="{{ accordionValue }}" toggleIconSlot="start">
  <ion-item slot="header" color="light">
    <ng-content select="[header]"></ng-content>
  </ion-item>
  <div slot="content">
    <ng-content></ng-content>
  </div>
</ion-accordion>
